import { useSelector } from "react-redux";
import BaseHeading from "../../../../baseComponents/baseHeading";
import RegionSelector from "../../../../components/RegionSelector";


const ProfileLeftSide = ({ setSelectedRegion, profileRegions }) => {
  ///////////////////////////////////////////////////////////////////////////////////// REDUX
  
  const userState = useSelector((state) => state.userState);


  ///////////////////////////////////////////////////////////////////////////////////// STYLE
  const styles = {
    userInfoContainer: {
      display: "flex",
      flexDirection: "column",
      margin: "0 20px",
    },
  };

  /////////////////////////////////////////////////////////////////////////////////////RENDER
  return (
    <>
      <div style={styles.userInfoContainer}>
        <BaseHeading translate={false}>
          {userState.name} {userState.surname}
        </BaseHeading>
        <BaseHeading h3 translate={false}>
          {userState.email}
        </BaseHeading>
      </div>
      <RegionSelector
        data={profileRegions}
        setSelectedRegion={setSelectedRegion}
      />
    </>
  );
};

export default ProfileLeftSide;
